import React from 'react';
import { useNavigate } from 'react-router-dom';
import QuickListPanel from '../components/QuickListPanel';

/**
 * Dedicated /quick-list route — full-screen, mobile-first listing flow.
 * Renders outside the normal AppLayout shell (no sidebar / no chrome)
 * so it works great on phones and tablets. User can exit back to /dashboard.
 */
export default function QuickList() {
  const navigate = useNavigate();
  return <QuickListPanel onExit={() => navigate('/dashboard')} />;
}
